import React from 'react'

export default function Footer() {
  return (
    <div className='footer'>
        <p>Powered by GFI</p>
    </div>
  )
}
